import { useCallback, useRef, useState } from 'react';

export const useNotificationCenter = () => {
  const [notifUnreadCount, setNotifUnreadCount] = useState(0);

  /**
   * Fonction permettant au NotificationCenter
   * de recevoir les notifications WebSocket.
   */
  const notifPushRef = useRef(null);
// gdgdhh
  /**
   * Notifications reçues avant que NotificationCenter
   * soit complètement monté.
   */
  const pendingNotificationsRef = useRef([]);

  /**
   * Enregistre la fonction utilisée pour pousser
   * les notifications vers NotificationCenter.
   */
  const registerNotifPush = useCallback((pushFn) => {
    notifPushRef.current = pushFn;

    /**
     * Si des notifications sont arrivées avant
     * l'enregistrement du composant, on les pousse maintenant.
     */
    if (pendingNotificationsRef.current.length > 0) {
      pendingNotificationsRef.current.forEach(
        ({ notification, unreadCount }) => {
          pushFn(notification, unreadCount);
        }
      );

      pendingNotificationsRef.current = [];
    }
  }, []);

  /**
   * Appelé par le WebSocket lorsqu'une nouvelle
   * notification arrive.
   */
  const handleNotificationNew = useCallback((data) => {
    console.log(
      '🔔 [NOTIFICATION CENTER] WebSocket notification:',
      data
    );

    if (!data) {
      console.warn(
        '[NOTIFICATION CENTER] Empty notification data'
      );
      return;
    }

    /**
     * Le backend doit envoyer :
     *
     * {
     *   notification: {...},
     *   unread_count: 3
     * }
     */
    const {
      notification: notif,
      unread_count: unreadCount,
    } = data;

    if (!notif) {
      console.warn(
        '[NOTIFICATION CENTER] Missing notification object:',
        data
      );

      return;
    }

    console.log(
      '🔔 [NOTIFICATION CENTER] New notification:',
      notif
    );

    /**
     * Met à jour le compteur non lu.
     */
    setNotifUnreadCount((currentCount) => {
      if (unreadCount !== undefined && unreadCount !== null) {
        return unreadCount;
      }

      return currentCount + 1;
    });

    /**
     * Si NotificationCenter est déjà prêt,
     * on lui transmet directement la notification.
     */
    if (notifPushRef.current) {
      notifPushRef.current(
        notif,
        unreadCount
      );

      return;
    }

    /**
     * Sinon on garde la notification en attente.
     */
    console.debug(
      '[NOTIFICATION CENTER] Notification queued until UI is ready'
    );

    pendingNotificationsRef.current.push({
      notification: notif,
      unreadCount,
    });
  }, []);

  return {
    notifUnreadCount,
    registerNotifPush,
    handleNotificationNew,
  };
};
